import aT from '../const/action-type'
import { setTag } from '@sentry/browser'
import { unwrapMaybe } from '@app/util/apollo/maybe-unwrap'

export default (data) => {
  if (typeof data === 'string' || data === undefined || data === null) {
    setTag('organizationId', unwrapMaybe(data))
  }
  return { type: aT.SET_ORGANIZATION_ID, data }
}
